<template>
  <div class="w-100">
    <Head>
      <!-- Primary Meta Tags -->

      <title>{{ t('meta.home.title')}}</title>
      <meta name="title" :content=" t('meta.home.title')">
      <meta name="description" :content="t('meta.home.description')">
      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" :content="appUrl + $route.path">
      <meta property="og:title" :content=" t('meta.home.title')">
      <meta property="og:description" :content="t('meta.home.description')">
      <meta property="og:image" content="/meta.jpeg">
      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" :content="appUrl + $route.path">
      <meta property="twitter:title" :content=" t('meta.home.title')">
      <meta property="twitter:description" :content=" t('meta.home.description')">
      <meta property="twitter:image" content="/meta.jpeg">
    </Head>
    <div v-if="isMobile" class="wrapper home">
      <TheHeader class="position-absolute"/>
      <main class="vw-100 d-flex pt-4">
        <div class="vw-100">
          <div class="sf-block-title mobile animate__animated animate__slideInDown px-3">
            <img class="logo mobile" src="@/assets/images/VTStack_logo.svg"
                 alt="logo vtstack mobile">
            <h1 class="mobile"> {{ t('site.subtitle') }} </h1>
            <h2 class="mobile"> {{ t('site.context') }} </h2>
          </div>
          <div class="sf-block-row">
            <div class="sf-block-col">
              <SFBlock class="mobile"
                       :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'graph_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Graph.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Graph.svg')"
                       :title="t('button.graph.html')"
                       :subtitle="t('button.graph.subtitle')"
              />
              <SFBlock class="mobile"
                       :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'design_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Design.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Design.svg')"
                       :title="t('button.design.html')"
                       :subtitle="t('button.design.subtitle')"
              />
              <SFBlock class="mobile"
                       :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'sound_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Sound.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Sound.svg')"
                       :title="t('button.sound.html')"
                       :subtitle="t('button.sound.subtitle')"
              />
              <SFBlock class="mobile"
                       :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'support_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Support.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Support.svg')"
                       :title="t('button.support.html')"
                       :subtitle="t('button.support.subtitle')"
              />
              <SFBlock class="mobile"
                       :clickable="true"
                       :click="displayPreview"
                       :icon="require('@/assets/images/icons/Play.svg')"
                       :bigIcon="true"
                       :subtitle="t('button.video.subtitle.html')"
              />
            </div>
          </div>
          <div class="video-button">
            <form @submit.prevent="sendForm"  v-if="formSubmitted === false">
          <div class="subtitle white w-100" v-html="t('newsletter.html')"></div>
          <p>
            <span v-if="formError === true" class="errormsg">{{ t('form.error.email') }}</span>
            <span v-if="formProcessing === true" >{{ t('form.processing') }}</span>
            </p>
          <div class="input-group">
            <input type="text" class="form-control"
                   :placeholder="$t('contact.form.email.placeholder')"
                   aria-label="email"
                  v-model="email" required v-bind:class="{ error: formError }"
                  :disabled="formProcessing">
                  <vue-recaptcha   ref="invisibleRecaptcha"
                              size="invisible" sitekey="6Ldp2lcgAAAAAJ1uPf6zRn1p2euXxtwsoWWJQEec">
                  </vue-recaptcha>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="submit"
                    v-bind:class="{ error: formError  }" :disabled="formProcessing">
                      {{ t('subscribe.button') }}
                    </button>
                  </div>
          </div>
          </form>
          <Transition name="slide-fade" v-else>
          <div>{{ t("form.newsletter.thankyou")}}</div>
          </Transition>
          </div>
        </div>
      </main>
      <TheFooter class=""/>
    </div>
    <div v-else class="wrapper home">
      <TheHeader class="position-absolute"/>
      <main class="vw-100 d-flex scalable">
        <div class="sf-block-mid-screen position-relative">
          <div class="sf-block-title animate__animated animate__slideInDown">
            <img class="logo" src="@/assets/images/VTStack_logo.svg" alt="logo vtstack">
            <h1 style="white-space: pre;"> {{ t('site.subtitle') }} </h1>
            <h2 style="white-space: pre;"> {{ t('site.context') }} </h2>
          </div>
          <div class="sf-block-left sf-block-row">
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock/>
            </div>
            <div class="sf-block-col">
              <SFBlock :hidden="true"/>
              <SFBlock :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'graph_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Graph.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Graph.svg')"
                       :title="t('button.graph.html')"
                       :subtitle="t('button.graph.subtitle')"
              />
            </div>
            <div class="sf-block-col">
              <SFBlock :hidden="true"/>
              <SFBlock :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'design_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Design.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Design.svg')"
                       :title="t('button.design.html')"
                       :subtitle="t('button.design.subtitle')"
              />
            </div>
          </div>
        </div>
        <div class="sf-block-mid-screen position-relative">
          <div class="sf-block-right sf-block-row">
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'support_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Support.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Support.svg')"
                       :title="t('button.support.html')"
                       :subtitle="t('button.support.subtitle')"
              />
              <SFBlock :clickable="true"
                       :link="{name: 'ProductsView', params: {productCategory: 'sound_assets',}}"
                       :background="require('@/assets/images/background/Bg_Btn_Sound.svg')"
                       :icon="require('@/assets/images/icons/Icon_Btn_Sound.svg')"
                       :title="t('button.sound.html')"
                       :subtitle="t('button.sound.subtitle')"
              />
            </div>
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock :clickable="true"
                       :click="displayPreview"
                       :icon="require('@/assets/images/icons/Play.svg')"
                       :bigIcon="true"
                       :subtitle="t('button.video.subtitle.html')"
              />
              <SFBlock/>
            </div>
            <div class="sf-block-col" style="visibility: hidden">
              <SFBlock/>
              <SFBlock/>
              <SFBlock/>
            </div>
          </div>
        </div>
      </main>
      <div class="video-button">
          <form @submit.prevent="sendForm"  v-if="formSubmitted === false">
          <div class="subtitle white w-100" v-html="t('newsletter.html')"></div>
          <p>
            <span v-if="formError === true" class="errormsg">{{ t('form.error.email') }}</span>
            <span v-if="formProcessing === true" >{{ t('form.processing') }}</span>
            </p>
          <div class="input-group">
            <input type="text" class="form-control"
                   :placeholder="$t('contact.form.email.placeholder')"
                   aria-label="email"
                  v-model="email" required v-bind:class="{ error: formError }"
                  :disabled="formProcessing">
                  <vue-recaptcha   ref="invisibleRecaptcha"
                              size="invisible" sitekey="6Ldp2lcgAAAAAJ1uPf6zRn1p2euXxtwsoWWJQEec">
                  </vue-recaptcha>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="submit"
                    v-bind:class="{ error: formError  }" :disabled="formProcessing">
                      {{ t('subscribe.button') }}
                    </button>
                  </div>
          </div>
          </form>
          <Transition name="slide-fade" v-else>
          <div>{{ t("form.newsletter.thankyou")}}</div>
          </Transition>
      </div>
      <div style="flex: 1 1 0;"></div>
      <TheFooter class="home"/>
    </div>
    <PreviewCanvas
      :class="{'offcanvas-on': showPreview}"
      :type="'video'"
      :mediaTitle="t('video.trailer.title')"
      :mediaUrl="t('video.trailer.link')"
      @close="closePreview"/>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helperMixin';
import TheHeader from '@/components/ui/TheHeader.vue';
import SFBlock from '@/components/ui/SFBlock.vue';
import PreviewCanvas from '@/components/canvas/PreviewCanvas.vue';
import TheFooter from '@/components/ui/TheFooter.vue';
import { Head } from '@vueuse/head';
import { APP_URL } from '@/common/config';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import qs from 'query-string';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'Homepage',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  mixins: [HelperMixin],
  components: {
    TheHeader,
    PreviewCanvas,
    SFBlock,
    TheFooter,
    Head,
    VueRecaptcha,
  },
  mounted() {
    const blocks = document.querySelectorAll('.sf-block');
    blocks.forEach((block, index) => {
      if (block.classList.contains('hidden')) {
        return;
      }
      setTimeout(() => {
        block.classList.add('active');
      }, index * 100);
    });
  },
  data() {
    return {
      showPreview: false,
      appUrl: APP_URL,
      email: '',
      formSubmitted: false,
      formError: false,
      formProcessing: false,
    };
  },
  methods: {
    displayPreview() {
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
    },
    validEmail(email) {
      // eslint-disable-next-line
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sendForm(e) {
      this.formProcessing = true;
      this.formError = false;
      e.preventDefault();
      if (!this.validEmail(this.email)) {
        this.formError = true;
        this.formProcessing = false;
        return false;
      }
      axios.post('https://sister.seriousfactory.com/api/web/form/webrequest', qs.stringify(
        {
          first_name: 'unknown',
          last_name: 'unknown',
          email: this.email,
          type: 'vtstack_newsletter',
          language: this.$i18n.locale,
        },
      )).then((response) => {
        // this.response = response.data
        this.formSubmitted = true;
        this.response = JSON.stringify(response, null, 2);
        this.formProcessing = false;
        return true;
      });
      return true;
    },
  },
};
</script>
